import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.28 12.464a2 2 0 0 1 .66 2.021l-.863 3.453 2.93-1.674a2 2 0 0 1 1.985 0l2.931 1.674-.863-3.453a2 2 0 0 1 .66-2.021l2.46-2.05-3.428-.43a2 2 0 0 1-1.59-1.196L12 6.078l-1.162 2.71a2 2 0 0 1-1.59 1.197l-3.428.428zM9 8l-4.571.571c-1.302.163-1.782 1.801-.774 2.641L7 14l-1.147 4.59c-.32 1.281 1.052 2.321 2.2 1.666L12 18l3.948 2.256c1.147.655 2.52-.385 2.2-1.666L17 14l3.346-2.788c1.008-.84.527-2.478-.775-2.64L15.001 8l-1.622-3.783c-.52-1.212-2.238-1.212-2.758 0z",
      clipRule: "evenodd"
    }
  )
);
var SvgStarOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var StarOutlined_default = SvgStarOutlined;

export { StarOutlined_default as default };
